import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { UsersService } from 'src/app/private/services/users.service';
import { AppCookieService } from 'src/app/utils/AppCookieService';
import { LocalStorageService } from 'src/app/utils/LocalStorageService';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class AuthService {
  constructor(
    private http: HttpClient,
    private localStorage: LocalStorageService,
    private cookies: AppCookieService,
    private usersService: UsersService,
  ) { }

  loginUser(data:any): Observable<any> {
    return this.http.post(environment.loginUser,data);
  }
  forgetPassword(data:any): Observable<any> {
    return this.http.post(environment.forgotPassword,data);
  }
  resetPassword(data:any): Observable<any> {
    return this.http.post(environment.resetPassword,data);
  }

  verifyOtp(data:any): Observable<any> {
    return this.http.post(environment.verifyOtp,data);
  }

  /** Check whether the current JWT session is still the active session in the DB. */
  validateSession(): Observable<any> {
    return this.http.post(environment.validateSession, {});
  }

  logOut(): void {
    this.cookies.remove('token');
    this.usersService.clearFindAllUsersInflight();
    this.localStorage.logout();
    try {
      sessionStorage.clear();
    } catch {
      /* non-browser or blocked storage */
    }
    try {
      localStorage.clear();
    } catch {
      /* non-browser or blocked storage */
    }
    void this.clearWebCachesAndOfflineStorage();
  }

  /**
   * Best-effort cleanup of client-side caches. HTTP cache cannot be cleared from JavaScript;
   * this clears Cache API, service workers, and IndexedDB where available.
   */
  private async clearWebCachesAndOfflineStorage(): Promise<void> {
    try {
      if (typeof caches !== 'undefined' && typeof caches.keys === 'function') {
        const keys = await caches.keys();
        await Promise.all(keys.map((k) => caches.delete(k)));
      }
    } catch {
      /* ignore */
    }
    try {
      if ('serviceWorker' in navigator) {
        const regs = await navigator.serviceWorker.getRegistrations();
        await Promise.all(regs.map((r) => r.unregister()));
      }
    } catch {
      /* ignore */
    }
    try {
      const idb = indexedDB as IDBFactory & {
        databases?: () => Promise<Array<{ name?: string }>>;
      };
      if (typeof idb.databases === 'function') {
        const dbs = await idb.databases();
        for (const db of dbs) {
          if (db?.name) {
            idb.deleteDatabase(db.name);
          }
        }
      }
    } catch {
      /* ignore */
    }
  }

}
